var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "t-player t-player--blank" }, [
    _c("div", { staticClass: "t-player__placeholder" }, [
      _c("p", { staticStyle: { "font-size": "44px" } }, [
        _c("i", {
          class: [
            "fas",
            "fa-" + (_vm.type == "link" ? "unlink" : "video-slash")
          ]
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n      " + _vm._s(_vm.descText) + "\n    ")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }